import { WatsonIcon } from '@tools/ui/assets';
import type { AppRouter } from '@tools/ui/types';
import { DimeShowcaseView } from '../DimeShowcaseView';

export const dimeShowcaseRoutes: AppRouter = {
  modules: [
    { redirectFrom: ['/dime-showcase-base'] },
    {
      name: 'Dime Showcase',
      path: '/dime-showcase',
      component: DimeShowcaseView,
      icon: WatsonIcon,
      pages: [],
      exact: false,
      noPadding: true
    }
  ]
};
